"use client";
// Aplica al sitio público los interruptores de módulos que decide el equipo (por ahora el bar). Sin servidor (vista previa) todo queda activo.
import { useEffect } from "react";
import { EVENTO_ITINERARIO } from "@/lib/itinerario";

const CLAVE = "sierra-tours-modulos-v1";
const aplicar = (m: { bar?: boolean; bar_reservas?: boolean; bar_galeria?: boolean; bar_carta?: boolean }) => {
  document.documentElement.toggleAttribute("data-bar-galeria-oculta", m.bar_galeria === false);
  document.documentElement.toggleAttribute("data-bar-carta-oculta", m.bar_carta === false);
  document.documentElement.toggleAttribute("data-bar-oculto", m.bar === false);
  document.documentElement.toggleAttribute("data-bar-reservas-oculto", m.bar === false || m.bar_reservas === false);
  window.dispatchEvent(new Event(EVENTO_ITINERARIO));
};

export function ModulosSitio() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_EXPORT === "1") return;
    try { const guardado = window.sessionStorage.getItem(CLAVE); if (guardado) aplicar(JSON.parse(guardado)); } catch { /* sin almacenamiento */ }
    fetch("/api/sitio/modulos", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((m) => { if (m) { try { window.sessionStorage.setItem(CLAVE, JSON.stringify(m)); } catch { /* sin almacenamiento */ } aplicar(m); } })
      .catch(() => { /* si no hay respuesta se conserva el último estado conocido */ });
  }, []);
  return null;
}
